"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const index_1 = require("../../index");
const TileDrawingTable_1 = require("./TileDrawingTable/TileDrawingTable");
var TileTableType;
(function (TileTableType) {
    TileTableType["DrawingTable"] = "DrawingTable";
    TileTableType["AttributesTable"] = "AttributesTable";
})(TileTableType || (TileTableType = {}));
const TileTable = ({ attributes, rows, tileType, showMoreLabel, showLessLabel, }) => {
    const tileTableType = React.useMemo(() => {
        if (index_1.TileTypeEnum.Document && rows && rows.length > 1) {
            return TileTableType.DrawingTable;
        }
        if (tileType === index_1.TileTypeEnum.SearchResults && attributes) {
            return TileTableType.AttributesTable;
        }
    }, [tileType]);
    if (tileTableType === TileTableType.DrawingTable) {
        return ((0, jsx_runtime_1.jsx)(TileDrawingTable_1.TileDrawingTable, { rows: rows, showMoreLabel: showMoreLabel, showLessLabel: showLessLabel }));
    }
    if (tileTableType === TileTableType.AttributesTable) {
        return ((0, jsx_runtime_1.jsx)(index_1.TileAttributesTable, { attributes: attributes, showMoreLabel: showMoreLabel, showLessLabel: showLessLabel }));
    }
    return null;
};
exports.TileTable = TileTable;
